/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Sync_ForkedInputs */

const cs_builder_sync_forked = /** @type {(inputs: Builder_Sync_ForkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odděleno`)
};

const en_builder_sync_forked = /** @type {(inputs: Builder_Sync_ForkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forked`)
};

/**
* | output |
* | --- |
* | "Forked" |
*
* @param {Builder_Sync_ForkedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_sync_forked = /** @type {((inputs?: Builder_Sync_ForkedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Sync_ForkedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_sync_forked(inputs)
	return cs_builder_sync_forked(inputs)
});